import { Field, ID, InputType } from 'type-graphql'
import type { IAction } from '../../../action/IAction'
import { ActionArgs } from '../../../action/ActionArgs'
import type { CreditTransaction } from '../CreditTransaction'

@InputType()
export class SettleCreditPurchaseArgs extends ActionArgs {
  @Field(() => ID)
  purchaseId: string

  /** Set at settlement, from the gateway's paid-event payload. Absent for a fully-discounted purchase, which settles with no gateway involved. */
  @Field(() => String, { nullable: true })
  gatewayPaymentId?: string
}

/**
 * Router-invoked only (never GraphQL-exposed) — the `null` result marks an idempotent no-op
 * (an already-`Paid` purchase, i.e. a replayed webhook) so the caller can distinguish it from
 * a genuine grant without inspecting side effects.
 */
export interface ISettleCreditPurchase extends IAction<CreditTransaction | null, SettleCreditPurchaseArgs> {}
